/* eslint-disable react/prop-types -- props validated via TypeScript InvestmentCardV2Props */
import React from 'react'

import { formatTitleCaseWords } from '../../lib/utils/helpers'

export type BadgeV2Type = 'coming-soon' | 'verified' | 'open' | 'due-diligence'

export interface InvestmentCardV2Props {
  id: number
  projectSlug: string
  title: string
  category: string
  description: string
  imageUrl: string
  fundingProgressPercent: number
  targetAmount: string
  minInvestment: string
  timeRemaining: string
  assetClass: string
  badges: { type: BadgeV2Type; label: string }[]
  ctaLabel: string
  onCtaClick: () => void
  dataTestId?: string
  /** Spotlighted opportunity (metadata.highlight_enabled): shows the "Live" treatment and green CTA. */
  isHighlighted?: boolean
}

export const InvestmentCardV2: React.FC<InvestmentCardV2Props> = ({
  title,
  category,
  description,
  imageUrl,
  minInvestment,
  ctaLabel,
  onCtaClick,
  dataTestId,
  isHighlighted = false,
}) => {
  const buttonText = isHighlighted ? 'Invest Now' : formatTitleCaseWords(ctaLabel)

  return (
    <article
      className={`home-v2__card${isHighlighted ? ' home-v2__card--highlighted' : ''}`}
      data-testid={dataTestId}
    >
      <div className='home-v2__card-image-wrap'>
        {isHighlighted && (
          <span className='home-v2__card-live-badge'>
            <span className='home-v2__card-live-dot' aria-hidden />
            Live
          </span>
        )}
        <img src={imageUrl} alt='' className='home-v2__card-image' loading='lazy' />
      </div>
      <div className='home-v2__card-body'>
        <p className='home-v2__card-category'>{category}</p>
        <h3 className='home-v2__card-title'>{title}</h3>
        <p className='home-v2__card-description'>{description}</p>
        <div className='home-v2__card-details home-v2__card-details--single'>
          <div>
            <p className='home-v2__card-detail-label'>MIN INVESTMENT</p>
            <p className='home-v2__card-detail-value'>{minInvestment}</p>
          </div>
        </div>
        <button
          type='button'
          className={`home-v2__card-cta${isHighlighted ? ' home-v2__card-cta--highlighted' : ''}`}
          onClick={onCtaClick}
        >
          {buttonText}
        </button>
      </div>
    </article>
  )
}
